import React, { useState } from 'react';
import styled from 'styled-components';
import { Buttons, CancelButton, DeleteButton, FormMessage, ModalCard } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { useIsMounted } from '~/hooks';
import { weights } from '~/styles';

const Description = styled.p`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  span {
    font-weight: ${weights.bold};
  }
`;

export default function DisconnectApp({ connection, onClose, onDisconnect }) {
  const api = useApi();
  const isMounted = useIsMounted();
  const { workspace } = useWorkspace();
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  async function handleDisconnect() {
    setIsDisconnecting(true);
    setErrorMessage();

    try {
      await api.www.workspaces(workspace.id).oauthConnections(connection.clientId).disconnect();

      if (typeof onDisconnect === 'function') {
        await onDisconnect();
      }
      if (typeof onClose === 'function') {
        await onClose();
      }
    } catch ({ message }) {
      setErrorMessage(message || 'There was a problem completing your request. Please try again later.');
    } finally {
      if (isMounted.current) {
        setIsDisconnecting(false);
      }
    }
  }

  return (
    <ModalCard title="Disconnect Application" onClose={onClose}>
      <ModalCard.Body>
        <Description>
          <span>{connection.name}</span> will immediately lose access to Ruddr. Anything it already did on your behalf
          stays as it is.
        </Description>
        <Description>You can connect it again at any time by authorizing it from the application.</Description>
        {errorMessage && <FormMessage.Error spaceTop>{errorMessage}</FormMessage.Error>}
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={onClose} style={{ marginRight: 'auto' }}>
            Cancel
          </CancelButton>
          <DeleteButton isLoading={isDisconnecting} onClick={handleDisconnect}>
            Disconnect
          </DeleteButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
